// extracted by mini-css-extract-plugin
export default {"AlternativeImage":"AlternativeImage_AlternativeImage__OTQwO"};